import { combineReducers } from '@reduxjs/toolkit';
import { reducer as couponReducer } from './services/coupon';

export const reducer = combineReducers({
  coupon: couponReducer,
});
